export const startType = (type) => `${type}_START`;
export const errorType = (type) => `${type}_ERROR`;

// Login
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const GET_USER_INFO = 'GET_USER_INFO';
export const TOKEN_ERROR = 'TOKEN_ERROR';

// Guarantee policy (GP)
export const GP_GET_LIST = 'GP_GET_LIST';
export const GP_GET_TIPOS_ENDOSO = 'GP_GET_TIPOS_ENDOSO';

// Credit policy (CP)
export const CP_GET_LIST = 'CP_GET_LIST';
export const CP_SET_CORREDOR_POLIZAS = 'CP_SET_CORREDOR_POLIZAS'

// Policy
export const POL_GET_MONEDAS = 'POL_GET_MONEDAS';
export const POL_GET_PRODUCTOS = 'POL_GET_PRODUCTOS';
export const POL_GET_TIPOS_COBERTURA = 'POL_GET_TIPOS_COBERTURA';

// Corredor guarantee policy (GP)
export const CORREDOR_GP_GET_LIST = 'CORREDOR_GP_GET_LIST';
export const CORREDOR_GP_GET_SUMMARY = 'CORREDOR_GP_GET_SUMMARY';
export const CORREDOR_GP_UPDATE_LIST_URLS = 'CORREDOR_GP_UPDATE_LIST_URLS';
export const CORREDOR_GP_CHANGE_FILTER_DATE = 'CORREDOR_GP_CHANGE_FILTER_DATE';
export const CORREDOR_GP_GET_PROD_MENSUAL = 'CORREDOR_GP_GET_PROD_MENSUAL';
export const CORREDOR_GP_GET_PROD_MENSUAL_SUMMARY = 'CORREDOR_GP_GET_PROD_MENSUAL_SUMMARY';
export const CORREDOR_GP_CHANGE_PROD_MENSUAL_FILTER_DATE =
  'CORREDOR_GP_CHANGE_PROD_MENSUAL_FILTER_DATE';
export const CORREDOR_GP_UPDATE_PROD_MENSUAL_LIST_URLS =
  'CORREDOR_GP_UPDATE_PROD_MENSUAL_LIST_URLS';

// Corredor credit policy (GP)
export const CORREDOR_CP_GET_LIST = 'CORREDOR_CP_GET_LIST';
export const CORREDOR_CP_GET_SUMMARY = 'CORREDOR_CP_GET_SUMMARY';
export const CORREDOR_CP_UPDATE_LIST_URLS = 'CORREDOR_CP_UPDATE_LIST_URLS';
export const CORREDOR_CP_CHANGE_FILTER_DATE = 'CORREDOR_CP_CHANGE_FILTER_DATE';
export const CORREDOR_CP_CHANGE_FILTER_YEAR = 'CORREDOR_CP_CHANGE_FILTER_YEAR';

// Liquidaciones
export const GET_LIQUIDACION_LIST = 'GET_LIQUIDACION_LIST';
export const LIQUIDACION_DOCS_URLS = 'LIQUIDACION_DOCS_URLS';


// acciones extras
export const SET_ACCIONES_PERMITIDAS = 'SET_ACCIONES_PERMITIDAS';
